module.exports = __webpack_public_path__ + "img/login-img0.6ecf9faf.svg";